// Major MCX commodity futures. Symbol names must match Angel One's scrip
// master "name" field exactly for instrument resolution to work -- re-sync
// this list if MCX adds/retires a contract.

export const MCX_COMMODITIES = [
  "GOLD", "GOLDM", "SILVER", "SILVERM",
  "CRUDEOIL", "NATURALGAS",
  "COPPER", "ZINC", "ALUMINIUM", "LEAD", "NICKEL",
  "COTTON", "MENTHAOIL",
];
